// @core/api/endpoints/calendar/delete_recurring_event_occurrence.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete recurring event occurrence
 * Deletes a single occurrence from a recurring event series by adding an exception. Other occurrences are unaffected.
 */
export async function DeleteRecurringEventOccurrence(
  event_id: string,
  original_start: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/occurrences/:original_start`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  requestPath = requestPath.replace(':original_start', encodeURIComponent(original_start));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
